@if (propsDataSource) {
  <div class="element-wrapper" [ngStyle]="wrapperStyles">
    <blaze-element-filter-header
      [filterBuilderTriggerTpl]="filterBuilderTriggerTpl"
      [fontColor]="titleColor"
      [hasBottomSpacing]="false"
      [labelEnabled]="labelEnabled"
      [labelFontFamily]="props?.style?.titleBlock?.fontFamily"
      [labelFontSize]="props?.style?.titleBlock?.fontSize"
      [labelFontStyle]="props?.style?.titleBlock?.fontStyle"
      [labelFontWeight]="props?.style?.titleBlock?.fontWeight"
      [labelIconAlign]="props?.content?.title?.iconPosition"
      [labelIconSize]="props?.style?.titleBlock?.iconSize"
      [labelIconColor]="props?.content?.title?.iconColor?.color1"
      [labelIcon]="icon"
      [labelTextAlign]="props?.content?.title?.align"
      [labelText]="labelText"
      [searchAndFilters]="props?.content?.searchAndFilters"
      [slots]="slots"
    />
    <ng-template #filterBuilderTriggerTpl let-fullWidth="fullWidth">
      @if (searchMode === SearchAndFiltersMode.FILTER_BUILDER) {
        <blaze-filter-builder-trigger [for]="filterBuilder" [fullWidth]="fullWidth" />
      }
    </ng-template>
    <div
      class="row"
      [class.!hidden]="
        !filterBuilder.showFilters || searchMode !== SearchAndFiltersMode.FILTER_BUILDER
      "
    >
      <blaze-filter-builder
        #filterBuilder
        [query]="query"
        [filters]="savedFilters"
        [showLoadingForSavedFilters]="savedFiltersLoading"
        [allowToCreatePublicFilters]="allowToSavePublicComplexFilters"
        [showSavedFiltersButton]="(runtimeModePublicOrSecure$ | async) !== true"
        (applyFilter)="applyComplexFilter($event)"
        (saveFilter)="saveComplexFilter($event)"
        (deleteFilter)="deleteComplexFilter($event)"
      />
    </div>
  </div>
} @else {
  <div
    class="text-primary-lighter py-12 px-16 flex items-center gap-8 bg-bat-complementary rounded-bat"
  >
    <mat-icon svgIcon="icon_info_16" class="text-primary-darker icon-24" />
    <span
      >Select Data Source and Columns for Filtering.<br />This will filter all components in the
      container using this data source.</span
    >
  </div>
}
